import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services';

import {
  GetFilteredLinesInfoParams,
  GetFilteredLinesInfoResponse,
} from '../lines.proto';

@Injectable({
  providedIn: 'root',
})
export class LinesInfoService {
  constructor(private readonly apiService: ApiService) {}

  getFilteredLinesInfo(
    getFilteredLinesInfoParams: GetFilteredLinesInfoParams
  ): Observable<GetFilteredLinesInfoResponse> {
    const params: HttpParams = this.apiService.queryParams(
      getFilteredLinesInfoParams
    );
    return this.apiService.get(`/v2-internal/lines`, params);
  }
}
